import {Component, OnInit} from '@angular/core';
import {UserService} from '../../service/user.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {MessagingService} from '../../service/messaging.service';

@Component({
  selector: 'app-popups',
  templateUrl: './popups.component.html',
  styleUrls: ['./popups.component.scss']
})
export class PopupsComponent implements OnInit {
  public popupBody;
  public titleObserver;
  public modalTitle;

  constructor(private _userService: UserService,
              public activeModal: NgbActiveModal,
              private msgService: MessagingService) {

    this.titleObserver = this.msgService.modalTitleSubject
      .subscribe((result) => {
        this.modalTitle = result;
      });
  }

  ngOnInit() {

    this._userService.modalPopupSubject
      .subscribe((result) => {
          if (result !== null) {
            this.popupBody = result;
          }
        },
        err => {});

  }

  copyAPIKey() {
    let tmpBuffer = document.createElement('textarea');
    tmpBuffer.style.position = 'fixed';
    tmpBuffer.style.right = '100000px';
    tmpBuffer.innerText = this.popupBody.token;
    document.body.appendChild(tmpBuffer);
    tmpBuffer.select();
    document.execCommand('copy');
    document.body.removeChild(tmpBuffer);
  }

}



// WEBPACK FOOTER //
// ./src/app/modal-edit/popups/popups.component.ts